export default __webpack_public_path__ + "static/media/bookos-italic.468790a7.ttf";